import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMarketHistoryThunk } from "../../store/thunks/rateThunks";
// If you have recharts installed, uncomment:
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const RateHistoryChart = ({ branchCode }) => {
  const dispatch = useDispatch();
  const { marketData } = useSelector((state) => state.rate);
  const [selectedMetal, setSelectedMetal] = useState("GOLD");

  useEffect(() => {
    if (branchCode) {
      dispatch(
        getMarketHistoryThunk({
          type: selectedMetal,
          days: 30,
          branchCode,
        })
      );
    }
  }, [dispatch, branchCode, selectedMetal]);

  const data = marketData.history || [];

  // Transform data for chart
  const chartData = data.map((item) => ({
    date: new Date(item.fetchedAt).toLocaleDateString("en-IN"),
    rate: item.marketRate,
    buyRate: item.marketBuyRate,
    sellRate: item.marketSellRate,
  }));

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">Rate History</h3>
        <div className="flex gap-2">
          {["GOLD", "SILVER", "PLATINUM"].map((metal) => (
            <button
              key={metal}
              onClick={() => setSelectedMetal(metal)}
              className={`px-3 py-1 rounded text-sm ${
                selectedMetal === metal
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
            >
              {metal}
            </button>
          ))}
        </div>
      </div>

      {branchCode && (
        <p className="text-sm text-gray-600 mb-2">Branch: {branchCode}</p>
      )}

      {/* If you have recharts installed, replace the placeholder with: */}
      {/*
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="rate" stroke="#8884d8" name="Base Rate" />
          <Line type="monotone" dataKey="buyRate" stroke="#82ca9d" name="Buy Rate" />
          <Line type="monotone" dataKey="sellRate" stroke="#ffc658" name="Sell Rate" />
        </LineChart>
      </ResponsiveContainer>
      */}

      <div className="h-64 flex items-center justify-center text-gray-500">
        {chartData.length > 0 ? (
          <div className="text-center">
            <p>Chart will be rendered here</p>
            <p className="text-sm mt-2">Data points: {chartData.length}</p>
          </div>
        ) : (
          <p>No history data available</p>
        )}
      </div>
    </div>
  );
};

export default RateHistoryChart;
